import React from "react";
import { Route, Switch } from "react-router-dom";
import { Auth } from "_helpers";
import TiepHome from "./tiep/Home";
import StrGrHome from "./str_gr/Home";
import PrymHome from "./prym/Home";
import OtrHome from "./otr/Home";
import StrRmHome from "./str_rm/Home";
import AquaHome from "./aqua/Home";
import Home from "./Home";

function Homes({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "STR_GR") {
    return (
      <Switch>
        <Route exact path={path} component={StrGrHome} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR") {
    return (
      <Switch>
        <Route exact path={path} component={StrRmHome} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "PRYM") {
    return (
      <Switch>
        <Route exact path={path} component={PrymHome} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "OTR") {
    return (
      <Switch>
        <Route exact path={path} component={OtrHome} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "TIEP") {
    return (
      <Switch>
        <Route exact path={path} component={TiepHome} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "AQUA") {
      return (
          <Switch>
              <Route exact path={path} component={AquaHome} />
          </Switch>
      );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={Home} />
      </Switch>
    );
  }
}

export { Homes };
